<agr-page-toolbar
  [pageTitle]="pageTitle"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="createTailBiting()"
  data-test="tail-biting--overview"
>
  <ng-container actions>
    <mat-select
      multiple
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-placeholder="{{ 'tail-biting-overview.location-selector' | translate }}"
      data-test="location-selector"
      (selectionChange)="changeLocation($event)"
      [compareWith]="areLocationsEqual"
      [value]="selectedLocations"
    >
      <mat-option *ngFor="let location of locationItems" [value]="location">
        {{ location.name }}
      </mat-option>
    </mat-select>
  </ng-container>

  <div class="spacing--margin-horizontal spacing--margin-top introtext">
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column">
          <span class="text--small label">
            {{ 'tail-biting.overview.intro-header' | translate }}<br />
          </span>
          <span class="text--small label text--bold spacing--margin-top">
            {{ 'tail-biting.overview.intro-introductie-titel' | translate }}
          </span>
          <span class="text--small label spacing--margin-top">
            {{ 'tail-biting.overview.intro-introductie-paragraph1' | translate }}
          </span>
          <span class="text--small label spacing--margin-top">
            {{ 'tail-biting.overview.intro-introductie-paragraph2' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="tableConfig$ | async as tableConfig">
    <agr-table
      *ngIf="tableConfig"
      [emptyTitle]="'tail-biting.overview.no-tail-biting.title' | translate"
      [emptyDescription]="'tail-biting.overview.no-tail-biting.description' | translate"
      emptyImage="assets/images/pigs_001.jpg"
      [config]="tableConfig"
      class="table"
    ></agr-table>
  </ng-container>
</agr-page-toolbar>
